var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 14,
    viewBox: "0 0 13 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.1914 11.6485C12.5574 12.0145 12.5574 12.6083 12.1914 12.9743C11.8254 13.3403 11.2316 13.3403 10.8656 12.9743L6.24999 8.32428L1.60155 12.9727C1.23558 13.3387 0.641787 13.3387 0.275771 12.9727C-0.0902441 12.6067 -0.0902051 12.0129 0.275771 11.6469L4.92577 7.00006L0.274482 2.31647C-0.0914941 1.95049 -0.0914941 1.3567 0.274482 0.990684C0.640459 0.624668 1.23425 0.624707 1.60026 0.990684L6.24999 5.67584L10.8984 1.0274C11.2644 0.661426 11.8582 0.661426 12.2242 1.0274C12.5902 1.39338 12.5902 1.98717 12.2242 2.35318L7.57421 7.00006L12.1914 11.6485Z",
    fill: "#2B2E33"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.a7d4ab7994bc060c0d20b0f1dc79e7db.svg";
export { ForwardRef as ReactComponent };